/**
 * GL iOS Blur Fix v2 — Runtime Blur Prevention
 * 
 * Aggressively prevents ANY element from applying filter:blur()
 * or backdrop-filter:blur() to the page. Uses MutationObserver
 * to catch dynamically injected styles from third-party apps.
 */
(function () {
  'use strict';

  // Protected elements - never allow blur on these
  var protectedTags = ['BODY', 'HTML', 'MAIN', 'HEADER', 'FOOTER', 'SECTION', 'DIV'];

  /**
   * Remove blur from an element's inline styles
   */
  function removeBlur(el) {
    if (!el || !el.style) return;
    if (el.classList && el.classList.contains('search-modal')) return; // Allow blur on search modal
    
    var style = el.getAttribute('style');
    if (!style) return;

    if (style.indexOf('blur') > -1 || style.indexOf('filter') > -1) {
      el.style.removeProperty('filter');
      el.style.removeProperty('-webkit-filter');
      el.style.removeProperty('backdrop-filter');
      el.style.removeProperty('-webkit-backdrop-filter');
    }
  }

  /**
   * Scan entire DOM for blur styles and remove them
   */
  function scanAll() {
    // Remove blur from all protected elements
    var all = document.querySelectorAll('[style*="blur"], [style*="filter"]');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      // Only remove blur/filter, not other filters like drop-shadow or grayscale
      var style = el.getAttribute('style') || '';
      if (style.indexOf('blur') > -1) {
        removeBlur(el);
      }
    }

    // Always clean body, html, main
    removeBlur(document.body);
    removeBlur(document.documentElement);
    var main = document.getElementById('MainContent');
    if (main) removeBlur(main);
  }

  // Run immediately
  scanAll();

  // Run on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', scanAll);

  // Run at intervals to catch late-loading app scripts
  var intervals = [500, 1000, 2000, 3000, 5000, 8000, 10000];
  intervals.forEach(function(ms) {
    setTimeout(scanAll, ms);
  });

  // MutationObserver to catch dynamically added blur styles
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];

        // Style attribute changed
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          var target = mutation.target;
          var style = target.getAttribute('style') || '';
          if (style.indexOf('blur') > -1) {
            removeBlur(target);
          }
        }

        // New nodes added (app injecting overlay elements)
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node.nodeType === 1) { // Element node
              var nodeStyle = node.getAttribute ? node.getAttribute('style') : '';
              if (nodeStyle && nodeStyle.indexOf('blur') > -1) {
                removeBlur(node);
              }
              // Check children too
              if (node.querySelectorAll) {
                var blurChildren = node.querySelectorAll('[style*="blur"]');
                for (var k = 0; k < blurChildren.length; k++) {
                  removeBlur(blurChildren[k]);
                }
              }
            }
          }
        }
      }
    });

    // Observe the entire document for style changes and new nodes
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style'],
      childList: true,
      subtree: true
    });
  }
})();
